
import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {ICookie} from '@app/cookie-consent/models/cookie-consent.model';
import {TranslateModule} from '@ngx-translate/core';
import {DividerModule} from 'primeng/divider';
import {TableModule} from 'primeng/table';

@Component({
  selector: 'app-cookie-table',
  imports: [TableModule, DividerModule, TranslateModule],
  templateUrl: './cookie-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieTableComponent {
  readonly cookies = input<ICookie[]>([]);
}
